// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    ApiTransactionAPIModel,
    ApiTransactionAPIModelFromJSON,
    ApiTransactionAPIModelToJSON,
    TransactionFilterAPIModel,
    TransactionFilterAPIModelFromJSON,
    TransactionFilterAPIModelToJSON,
    TransactionsSliceAPIModel,
    TransactionsSliceAPIModelFromJSON,
    TransactionsSliceAPIModelToJSON,
} from '../models';

export interface GetTransactionByIdRequest {
    transactionId: number;
}

export interface GetTransactionHistoryRequest {
    transactionFilterAPIModel: TransactionFilterAPIModel;
}

/**
 * TransactionApi - interface
 * 
 * @export
 * @interface TransactionApiInterface
 */
export interface TransactionApiInterface {
    /**
     * Returns transaction by id
     * @param {number} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApiInterface
     */
    getTransactionByIdRaw(requestParameters: GetTransactionByIdRequest): Promise<runtime.ApiResponse<ApiTransactionAPIModel>>;

    /**
     * Returns transaction by id
     */
    getTransactionById(transactionId: number): Promise<ApiTransactionAPIModel>;

    /**
     * Find transaction history
     * @param {TransactionFilterAPIModel} transactionFilterAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApiInterface
     */
    getTransactionHistoryRaw(requestParameters: GetTransactionHistoryRequest): Promise<runtime.ApiResponse<TransactionsSliceAPIModel>>;

    /**
     * Find transaction history
     */
    getTransactionHistory(transactionFilterAPIModel: TransactionFilterAPIModel): Promise<TransactionsSliceAPIModel>;

}

/**
 * 
 */
export class TransactionApi extends runtime.BaseAPI implements TransactionApiInterface {

    /**
     * Returns transaction by id
     */
    async getTransactionByIdRaw(requestParameters: GetTransactionByIdRequest): Promise<runtime.ApiResponse<ApiTransactionAPIModel>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling getTransactionById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/transactions/{transactionId}`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiTransactionAPIModelFromJSON(jsonValue));
    }

    /**
     * Returns transaction by id
     */
    async getTransactionById(transactionId: number): Promise<ApiTransactionAPIModel> {
        const response = await this.getTransactionByIdRaw({ transactionId: transactionId });
        return await response.value();
    }

    /**
     * Find transaction history
     */
    async getTransactionHistoryRaw(requestParameters: GetTransactionHistoryRequest): Promise<runtime.ApiResponse<TransactionsSliceAPIModel>> {
        if (requestParameters.transactionFilterAPIModel === null || requestParameters.transactionFilterAPIModel === undefined) {
            throw new runtime.RequiredError('transactionFilterAPIModel','Required parameter requestParameters.transactionFilterAPIModel was null or undefined when calling getTransactionHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransactionFilterAPIModelToJSON(requestParameters.transactionFilterAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionsSliceAPIModelFromJSON(jsonValue));
    }

    /**
     * Find transaction history
     */
    async getTransactionHistory(transactionFilterAPIModel: TransactionFilterAPIModel): Promise<TransactionsSliceAPIModel> {
        const response = await this.getTransactionHistoryRaw({ transactionFilterAPIModel: transactionFilterAPIModel });
        return await response.value();
    }

}
